import { getProfileForEditAsync } from '@/services/authService'

export const auth = {
  namespaced: true,
  state: {
    user: null,
    token: null
  },
  getters: {
    getAuthenticatedUser(state) {
      return state.user
    },
    getAuthenticatedUserInfo(state) {
      return {fullname:state.user.fullname,
              email:state.user.email
      }
    },
    isAuthenticated(state) {
      return !!state.token
    },
    getToken(state){
      return state.token;
    }
  },
  mutations: {
    storeAuthenticatedUser(state, data) {
      localStorage.setItem("user", JSON.stringify(data.user))
      localStorage.setItem("token", data.token)
      state.user = data.user
      state.token = data.token
    },
    clearAuthenticatedUser(state) {
      localStorage.removeItem("user")
      localStorage.removeItem("token")
      state.user = null
      state.token = null
    },
    setAlreadyStoredAuthenticatedUserFromStorage(state) {
      const user = localStorage.getItem("user")
      const token = localStorage.getItem("token")
      state.user = user ? JSON.parse(user) : null
      state.token = token || null
    },
    updateProfile(state, data) {
      const updatedUser = { ...state.user, ...data.user };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      state.user = updatedUser;
    },
    setAuthenticatedUser(state, data){
      state.user = data
    }
  },
  actions: {
    setAuthenticatedUser({ commit }, data) {
      commit('storeAuthenticatedUser', data)
    },
    logout({ commit }) {
      commit('clearAuthenticatedUser')
    },
    initAuth({ commit }) {
      commit('setAlreadyStoredAuthenticatedUserFromStorage')
    },
    updateProfile({ commit }, data) {
    commit('updateProfile', data)
  },
  unauthenticateUser({commit}){
    commit('unauthenticateUser');
  },
  async getProfileInformationForEditAsync({state,commit}){
              
                  var res = await getProfileForEditAsync();
                  if(!res.success){
                      const err = new Error(res.message);
                      err.caption = res.caption;
                      throw err;
                  }else{
                      commit('setAuthenticatedUser', res.user);
                  }
              
          },
  }
}